import {
  GoogleLogin as OriginalGoogleLogin,
  CredentialResponse,
} from '@react-oauth/google';
import { isMobile } from 'react-device-detect';

type PropsType = {
  handleSuccess: (token: string) => void;
};

const GoogleLogin = (props: PropsType) => {
  const { handleSuccess } = props;

  const onSuccess = (response: CredentialResponse) => {
    handleSuccess(response.credential || '');
  };

  return (
    <OriginalGoogleLogin
      width={isMobile ? '336px' : '390px'}
      shape="circle"
      onSuccess={onSuccess}
    />
  );
};

export default GoogleLogin;
